import React from 'react';
import { Status } from '../../../js/api';
import { Button } from '../components/button';
import { StatusCodes } from '../constants/workflows';
import { StatusMetadata, WorkflowStatus } from '../hooks/useWorkflowMetadata';
import { getStatusButtonStyle } from './statusStyles';
import { useWorkflowAccess } from './workflowAccess';

type StatusTransitionButtonsProps = {
  isLoading: boolean;
  currentStatusCode: string | undefined;
  workflowMetadata: StatusMetadata;
  onStatusUpdate?: (status: Status) => void;
  onStatusClick?: (status: Status) => void;
  isPending?: boolean;
  small?: boolean;
  disabledMap?: Partial<Record<StatusCodes, boolean>>;
};

export const StatusTransitionButtons = ({
  isLoading,
  currentStatusCode,
  workflowMetadata,
  onStatusUpdate,
  onStatusClick,
  isPending = false,
  small = false,
  disabledMap,
}: StatusTransitionButtonsProps): React.ReactElement => {
  const { renderableStatusesFrom } = useWorkflowAccess(workflowMetadata);
  const renderableStatuses: WorkflowStatus[] = renderableStatusesFrom(currentStatusCode);

  if (isLoading) {
    return <></>;
  }
  if (!currentStatusCode || !workflowMetadata) {
    return <></>;
  }

  // Use onStatusClick if provided (opens modal pattern), otherwise fall back to onStatusUpdate
  const handleClick = onStatusClick || onStatusUpdate;
  if (!handleClick) {
    console.warn(
      'StatusTransitionButtons: Either onStatusClick or onStatusUpdate must be provided'
    );
    return <></>;
  }

  // Audience filtering handled by useWorkflowAccess

  return (
    <>
      {renderableStatuses.map((status) => (
        <Button
          key={status.code}
          color={getStatusButtonStyle(status)}
          onClick={() => handleClick(status)}
          disabled={isPending || disabledMap?.[status.code as StatusCodes] === false}
          small={small}
        >
          {status.verb}
        </Button>
      ))}
    </>
  );
};
